export default __webpack_public_path__ + "static/media/choose-2.a3ea7eee.png";